import React from "react";

import {
  View,
  StyleSheet,
  Text,
  TouchableOpacity,
  Platform,
} from "react-native";

import RoundCheckbox from "../../common/RoundCheckbox";
import AppTheme from "../../AppTheme";
import ManaMinutesDuration from "../../common/ManaMinutesDuration";
import MoodColors from "../../common/mood/MoodColors";
import LockIcon from "../../common/icons/LockIcon";
import appStyles from "../../../appStyles";

export default function ChecklistItemModel({ item, goToPage = () => {} }) {
  const extraStyle = [
    item.isComplete ? styles.complete : {},
    item.isLocked ? styles.locked : {},
  ];

  return (
    <TouchableOpacity onPress={() => goToPage(item)} style={styles.row}>
      <View style={[styles.number, ...extraStyle]}>
        <Text style={[styles.numberText, ...extraStyle]}>{item.index}</Text>
      </View>

      <View style={{ flex: 1 }}>
        <Text style={[styles.tutorialText, ...extraStyle]}>{item.text}</Text>
      </View>

      {item.isLocked ? (
        <Text style={styles.lockedText}>{item.lockedText}</Text>
      ) : (
        <ManaMinutesDuration
          minutes={item.duration}
          style={[styles.tutorialText, item.isComplete ? styles.complete : {}]}
        />
      )}

      {item.isLocked ? (
        <LockIcon style={appStyles.iconContainer} />
      ) : (
        <RoundCheckbox size={16} checked={item.isComplete} />
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  row: {
    height: 44,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: "#F5F5F5",
    paddingLeft: 16,
  },
  number: {
    width: 24,
    height: 24,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: AppTheme.DEFAULT_COLOR,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
  },
  numberText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  tutorialText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    paddingTop: 0,
  },
  complete: {
    borderColor: "#8B92A1",
    color: "#8B92A1",
  },
  locked: {
    borderColor: AppTheme.almostBlack,
    color: AppTheme.almostBlack,
  },
  imageBg: {
    width: 343,
    height: 267,
    marginTop: 27,
    marginBottom: 40,
    flex: 1,
  },
  lockedText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
    maxWidth: 75,
    textAlign: "right",
  },
});
